export const DISMISS_REVIEW_MODAL = 'dismiss-review-modal';
const dismissReviewModal = () => ({ type: DISMISS_REVIEW_MODAL });
export default dismissReviewModal;
